import React, { useState, useEffect, useContext } from "react";

import BulkChange from "./components/bulk-change";
import BulkToggle from "./components/bulk-toggle";
import Product from "./components/product";
import Accordion from "components/accordion";
import { ProductLabel } from "./components/product-label";
import { SettingsContext } from "../../contexts/settings";

const SchedulingData = ({ onValidateGroupAttributes, coreSchedulingDefinitions, refetchDefinitions, invalidGroupAttributes, ...props }) => {
    const { settings } = useContext(SettingsContext);
    const [missingAttributesList, setMissingAttributesList] = useState([]);
    const [defaultOpenedList, setDefaultOpenedList] = useState([]);
    const hasBulk = props.upcList.length > 1 && !props.readOnlyEdit;

    useEffect(() => {
        if (props.taskInfo) {
            const exactMatchFilter = props.taskInfo
                .filter((product) => product.context.productMatchType === 2 && product.isCompleted)
                .map((product) => product.key);
            const filteredUpcIndexes = props.upcList
                .filter((upc) => !exactMatchFilter.includes(upc.profilingTaskKey))
                .map((upc) => props.upcList.indexOf(upc));

            setDefaultOpenedList(filteredUpcIndexes);
        }
    }, [props.taskInfo, props.upcList]);

    const upcs = props.upcList.map((upc) => {
        const fullUpc = upc.productModifier ? `${upc.upc}-${upc.productModifier}` : upc.upc;

        return (
            <div
                key={`upcData_${upc.codingWipKey}`}
                label={
                    <ProductLabel
                        fullUpc={fullUpc}
                        upc={upc}
                        taskInfo={props.taskInfo}
                        isCompleted={props.isCompleted}
                        taskType={props.tasktype}
                        refresh={props.refresh}
                        readOnlyEdit={props.readOnlyEdit}
                        readOnlyComplete={props.readOnlyComplete}
                        missingAttributesList={missingAttributesList}
                        setMissingAttributesList={setMissingAttributesList}
                    />
                }
            >
                <Product
                    upc={upc}
                    companyName={props.companyName}
                    hasBulk={hasBulk}
                    showValidation={props.showValidation}
                    isCompleted={props.isCompleted}
                    taskType={props.tasktype}
                    taskInfo={props.taskInfo}
                    refresh={props.refresh}
                    saveCodingWipKey={!hasBulk}
                    definitions={coreSchedulingDefinitions}
                    refetchDefinitions={refetchDefinitions}
                    onValidateGroupAttributes={onValidateGroupAttributes}
                    invalidGroupAttributes={invalidGroupAttributes}
                    readOnlyAdd={props.readOnlyAdd}
                    readOnlyEdit={props.readOnlyEdit}
                    readOnlyComplete={props.readOnlyComplete}
                    readOnlyNotes={props.readOnlyNotes}
                    missingAttributesList={missingAttributesList}
                    setMissingAttributesList={setMissingAttributesList}
                    settings={settings}
                />
            </div>
        );
    });

    return (
        <div>
            <Accordion
                className="upc-list"
                enableSeparator={false}
                startingIndexes={defaultOpenedList}
            >
                {upcs}
            </Accordion>

            {hasBulk && <BulkToggle upcs={props.upcList} />}
            {hasBulk && (
                <BulkChange
                    definitions={coreSchedulingDefinitions}
                    upcs={props.upcList}
                />
            )}
        </div>
    );
};

export default SchedulingData;
